const GridComponentField = [
    "getPrefetch",
    "getVisibilityFetch",
    "getVisibility",
    "minHeight",
    "maxHeight",
    "minWidth",
    "maxWidth"
];
export function isGridComponent(component) {
    return GridComponentField.some(f => component.hasOwnProperty(f));
}
//# sourceMappingURL=types.js.map